import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'

export type VoltageClass = 'low' | 'high' | 'extraHigh'

export const VOLTAGE_CLASSES: readonly VoltageClass[] = [
  'low',
  'high',
  'extraHigh',
] as const

export const VOLTAGE_CLASS_I18N_KEYS: Record<VoltageClass, string> = {
  low: 'page:adminLossRate.voltageClass.low',
  high: 'page:adminLossRate.voltageClass.high',
  extraHigh: 'page:adminLossRate.voltageClass.extraHigh',
}

export type LossRateValues = Record<VoltageClass, number>

export type LossRateSetting = {
  areaCode: AreaCode
  current: LossRateValues
  /** 現在の設定の適用開始日 (発効日、"YYYY-MM-DD"). */
  currentEffectiveDate: string
  next:
    | {
        effectiveDate: string
        values: LossRateValues
      }
    | undefined
}
